module.exports = __webpack_public_path__ + "r-v3/img/sticker_2.1e30a743.svg";